<template>
  <v-container fluid>
    <customer-context-prompt :resource="product"/>
    <h2>{{ $tc('product') }} {{ product.name }}</h2>
    <product-form :product="product" @saved="productUpdated($event)"></product-form>
  </v-container>
</template>

<script>
import ProductForm from './ProductForm'
import CustomerContextPrompt from '@/components/shared/CustomerContextPrompt'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

export default {
  components: {
    CustomerContextPrompt,
    ProductForm
  },
  mixins: [
    BrowserUtilitiesMixin,
    CurrentUserMixin
  ],
  data () {
    return {
      product: {
        name: '',
        zone: '',
        min_temp: 0.0,
        max_temp: 0.0,
        start_temp: 0.0,
        coefficient: 0.0,
        add_by_default: 0,
        product_detail: {}
      }
    }
  },
  methods: {
    fetchProduct () {
      this.$orm('Product')
        .find(this.$route.params.id, {
          params:
            {
              expand: 'product_detail',
              fields: [
                'add_by_default',
                'coefficient',
                'created',
                'customer_id',
                'deleted',
                'id',
                'max_start_temp',
                'max_temp',
                'min_start_temp',
                'min_temp',
                'name',
                'start_temp',
                'temperature_scale',
                'updated',
                'zone'
              ].join(',')
            }
        })
        .then((product) => {
          // The input formatter only works with user input, not preset values,
          // so we need format them here first
          product.min_temp = Number(product.min_temp.toFixed(1))
          product.max_temp = Number(product.max_temp.toFixed(1))
          product.start_temp = Number(product.start_temp.toFixed(1))
          this.product = product

          this.updateBrowserTitle(`${this.$tc('product')} ${product.name}`)
        })
        .catch(error => {
          this.handleError(error)
        })
    },
    productUpdated (product) {
      this.$store.dispatch(
        'globalMessagingModule/showSuccessFlashBanner',
        `${this.$i18n.tc('product')} ${this.$i18n.t('generic_save_success')}`
      )
    }
  },
  mounted () {
    this.fetchProduct()
  }
}
</script>

<style>
</style>
